import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import Paginador from "./components/Paginador";

export default function Transportistas(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[listaTransportistas, setListaTransportistas] = useState(<></>);

    // ESTADOS DE FILTRO
    const[filtroTransportista, setFiltroTransportista] = useState("");
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerListaTransportistas("",1);
    },[]);

    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    // ESTADOS DE CONTENIDO
    const HandlerListaTransportistas = (valor) => setListaTransportistas(valor);
    // ESTADOS DE FILTRO
    const HandlerFiltroTransportista = (valor) => setFiltroTransportista(valor.toUpperCase());
    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);
    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerListaTransportistas = async(transportista, pagina) => {
        const paramTransportista = transportista == "" ? "-" : transportista;
        try{
            const response = await axios.get(URL_LISTAR_TRANSPORTISTAS,{
                headers: HEADERS_API,
                params: {
                    fTransportista: paramTransportista,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });
            HandlerListaTransportistas(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error);
        }
    }

    // FUNCIONES COMPLEMENTARIAS
    const QuitarFiltros = () => {
        HandlerFiltroTransportista("");
        ObtenerListaTransportistas("", 1);
    }

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaTransportistas(filtroTransportista, pagina);
    }
    
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>TRANSPORTISTAS</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nuevo-transportista"}>
                    <button className="btn btn-primary">Nuevo Transportista</button>
                </Link>
            </div>
            {/* FILTROS */}
            <div className="col-12 col-md-10 p-1">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroTransportista(e.target.value)} value={filtroTransportista} maxLength={50} type="text" className="form-control" placeholder="Buscar" id="filtro-transportista" autoComplete="off"/>
                    <label htmlFor="filtro-transportista">Buscar</label>
                </div>
            </div>
            <div className="col-12 col-md-2">
                <button onClick={e=>ObtenerListaTransportistas(filtroTransportista, 1)} className="btn btn-primary my-1 w-100">Filtrar</button>
                <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
            </div>
            {/* TABLA */}
            <div className="contenedor-tabla py-4">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>N° RUC</th>
                            <th>Razón Social</th>
                            <th>Registro MTC</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaTransportistas.length > 0 ? listaTransportistas.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.ruc}</td>
                                    <td>{item.razSoc}</td>
                                    <td>{item.registroMTC}</td>
                                    <td>
                                        <Link to={`/detalle-transportista/${item.ruc}`} className="btn btn-primary">
                                        Detalles
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center">
                {paginador}
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_LISTAR_TRANSPORTISTAS = process.env.REACT_APP_URL_LISTAR_TRANSPORTISTAS
//#endregion